import clsx from "clsx";

import { TextTooltip } from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { copyToClipboard } from "@lib/browser-utils";

import "./copy.button.scss";

export const CopyButton = ({ confirmationText, value, onClick, className }) => {
  const text = confirmationText ?? "Copied to clipboard";

  const onCopy = () => {
    copyToClipboard(value);
    onClick?.();
  };

  return (
    <TextTooltip
      className={clsx("info", className)}
      text={text}
      trigger="click"
    >
      <Button
        className={clsx("copy-button", className)}
        icon={["fa-regular", "fa-copy"]}
        onClick={onCopy}
        size="small"
        borderless
      />
    </TextTooltip>
  );
};
